import { gql } from "@apollo/client";

export const AGENCY_ANALYTICS_JOB_QUERY = gql`
  query GetAnalyticJobData(
    $year: Int!
    $month: Int!
  ) {
    getAnalyticJobData(year: $year, month: $month) {
      startDate
      jobPublished
      avgHireTime
      interested
      shortlisted
      approved
      hired
      dailyHireds
      topRoles {
        name
        interested
        shortlisted
        hired
      }
      previous {
        jobPublished
        avgHireTime
        interested
        shortlisted
        approved
        hired
        dailyHireds
      }
    }
  }
`;